"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSelectSubject = void 0;
const server_1 = require("../../../server");
const functions_1 = require("../../../server/functions");
const getSelectSubject = async (data, noFilterCommon) => {
    const queryString = (0, functions_1.objectToQueryString)({ ...data, orderby: 'subject_item' });
    const grades = await (0, server_1.getGrades)(queryString);
    const { items } = grades.result;
    const list = items.map(({ subject_item }) => subject_item);
    if (noFilterCommon)
        return list;
    // 공통과목 제거
    const filteredList = list.filter((item) => item !== '공통');
    return filteredList;
};
exports.getSelectSubject = getSelectSubject;
